"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const react_onclickout_1 = __importDefault(require("react-onclickout"));
const react_color_1 = require("react-color");
const CustomColorsContext_1 = require("./CustomColorsContext");
// Simple color well with popup
class ColorComponent extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.state = { open: false, advanced: false };
    }
    handleClick = () => {
        return this.setState({ open: !this.state.open, advanced: false });
    };
    handleColor = (color) => {
        return this.props.onChange(color.hex);
    };
    handleReset = () => {
        this.setState({ open: false });
        return this.props.onChange(null);
    };
    handleTransparent = () => {
        this.setState({ open: false });
        return this.props.onChange("transparent");
    };
    handleAdvanced = () => {
        return this.setState({ advanced: !this.state.advanced });
    };
    renderPopup() {
        if (!this.state.open || !this.colorWellRef)
            return null;
        const rect = this.colorWellRef.getBoundingClientRect();
        const popupPosition = {
            position: "fixed",
            top: `${rect.bottom + window.scrollY}px`,
            left: `${rect.left + window.scrollX}px`,
            zIndex: 1070,
            backgroundColor: "white",
            border: "solid 1px #DDD",
            borderRadius: 3
        };
        return react_dom_1.default.createPortal(react_1.default.createElement(react_onclickout_1.default, { onClickOut: () => this.setState({ open: false }) },
            react_1.default.createElement("div", { style: popupPosition },
                !this.props.disableReset && (react_1.default.createElement("button", { type: "button", className: "btn btn-link btn-sm", onClick: this.handleReset },
                    react_1.default.createElement("i", { className: "fa fa-undo" }),
                    " ",
                    T `Reset Color`)),
                react_1.default.createElement("button", { type: "button", className: "btn btn-link btn-sm", onClick: this.handleAdvanced }, this.state.advanced ? T `Basic` : T `Advanced`),
                react_1.default.createElement(CustomColors, { color: this.props.color, onChange: this.props.onChange }),
                this.state.advanced ? (react_1.default.createElement(react_color_1.SketchPicker, { color: this.props.color || undefined, disableAlpha: true, onChangeComplete: this.handleColor })) : (react_1.default.createElement(react_color_1.SwatchesPicker, { color: this.props.color || undefined, onChangeComplete: this.handleColor })))), document.body);
    }
    colorWellRef = null;
    render() {
        const style = {
            height: 20,
            width: 20,
            border: "solid 2px #888",
            borderRadius: 4,
            backgroundColor: this.props.color || undefined,
            cursor: "pointer",
            display: "inline-block"
        };
        if (!this.props.color) {
            // http://lea.verou.me/css3patterns/#diagonal-stripes
            style.backgroundColor = "#AAA";
            style.backgroundImage =
                "repeating-linear-gradient(45deg, transparent, transparent 2px, rgba(255,255,255,.7) 2px, rgba(255,255,255,.7) 4px)";
        }
        return (react_1.default.createElement("div", { style: { position: "relative", display: "inline-block" } },
            react_1.default.createElement("div", { style: style, onClick: this.handleClick, ref: ref => this.colorWellRef = ref }),
            this.renderPopup()));
    }
}
exports.default = ColorComponent;
/**
 * Custom colors component for the color picker that allows the user to select from a set of custom colors
 * that are defined in CSS variables.
 * @param props
 * @returns
 */
function CustomColors(props) {
    const customColors = (0, react_1.useContext)(CustomColorsContext_1.CustomColorsContext);
    return (react_1.default.createElement("div", { style: { display: 'grid', gridTemplateColumns: 'repeat(5, 42px)', gap: 8, margin: 5, marginLeft: 16 } }, customColors?.customColors.filter(color => color != null).map((color) => {
        const isSelected = props.color === color;
        return (react_1.default.createElement("div", { key: color, title: color, tabIndex: 0, onClick: () => props.onChange(color), style: {
                background: color,
                height: '24px',
                width: '40px',
                cursor: 'pointer',
                position: 'relative',
                outline: 'none',
                marginBottom: '1px',
                overflow: 'hidden',
                boxShadow: isSelected ? `${color} 0 0 4px` : 'none'
            } }, isSelected && (react_1.default.createElement("div", { style: { color: '#FFFFFF', marginLeft: '8px' } },
            react_1.default.createElement("svg", { viewBox: "0 0 24 24", style: { fill: 'currentcolor', width: '24px', height: '24px' } },
                react_1.default.createElement("path", { d: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" }))))));
    })));
}
